import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var Icon = /*#__PURE__*/function (_Component) {
  _inherits(Icon, _Component);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          name = _this$props.name,
          size = _this$props.size;
      var icon, icon_style;

      if (size === 'small') {
        icon_style = {
          width: 20,
          height: 20
        };
      } else {
        icon_style = {
          width: size,
          height: size
        };
      }

      icon_style = this.props.iconStyle ? this.props.iconStyle : icon_style;

      if (name === 'pencil') {
        icon = /*#__PURE__*/React.createElement("svg", {
          style: icon_style,
          fill: color,
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 1024 1024"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M964.256 49.664c-34.864-33.408-73.323-50.336-114.379-50.336-64.192 0-111.024 41.472-123.841 54.176-18.032 17.856-633.152 633.2-633.152 633.2-4.016 4.032-6.943 9.072-8.447 14.592-13.872 51.264-83.36 278.72-84.049 281.008-3.568 11.648-.385 24.337 8.207 32.929 6.176 6.144 14.399 9.439 22.831 9.439 3.312 0 6.655-.496 9.919-1.568 2.352-.768 237.136-76.655 275.775-88.191 5.088-1.536 9.744-4.288 13.536-8.032 24.416-24.128 598.128-591.456 636.208-630.784 39.392-40.592 58.96-82.864 58.208-125.616-.784-42.208-21.248-82.848-60.816-120.816zm-248.411 106.176c16.304 3.952 54.753 16.862 94.017 56.478 39.68 40.032 50.416 85.792 52.416 96.208-125.824 125.168-415.456 411.728-529.632 524.672-10.544-24.56-27.584-54.144-54.992-81.76-33.472-33.727-67.536-52.783-93.809-63.503 112.992-113.008 408.08-408.224 532-532.096zm-575.455 586.11c17.584 4.672 54.111 18.224 91.344 55.76 28.672 28.912 42.208 60.8 48.288 80.24-44.48 14.304-141.872 47.92-203.76 67.872 18.336-60.336 49.312-154.304 64.128-203.872zm780.031-491.584c-1.312 1.344-3.474 3.535-6.065 6.159-10.112-26.048-27.856-59.52-58.576-90.495-31.392-31.648-63.231-50.32-88.751-61.36l4.512-4.496c3.664-3.616 36.897-35.376 78.32-35.376 23.84 0 47.248 10.88 69.616 32.32 26.512 25.424 40.176 50.512 40.624 74.592.432 24.576-12.912 51.04-39.68 78.656z"
        }));
      } else if (name === 'twitterImageUpload') {
        icon = /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          style: icon_style,
          fill: color,
          viewBox: "0 0 100 100"
        }, /*#__PURE__*/React.createElement("g", {
          transform: "translate(-10,90) scale(0.05,-0.05)"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M362 170h936l-536 534l-462 -472q0 -26 18 -44t44 -18zM1686 170q26 0 45 19t19 45v316l-374 374l-324 -328l426 -426h208zM757 1342q55 0 93 -38t38 -93t-38 -93t-93 -38t-93 38t-38 93t38 93t93 38zM1686 1622h-1324q-26 0 -45 -19t-19 -45v-1144l418 426q45 45 90 0\nl154 -154l370 374q20 20 45 20t45 -20l330 -328v826q0 26 -19 45t-45 19zM362 1750h1324q80 0 136 -56t56 -136v-1324q0 -80 -56 -136t-136 -56h-1324q-80 0 -136 56t-56 136v1324q0 80 56 136t136 56z"
        })));
      } else if (name === 'messenger') {
        icon = /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          style: icon_style,
          viewBox: "0 0 224 226"
        }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
          id: "a",
          y1: "6.76%",
          x2: "50%",
          x1: "50%",
          y2: "95.6%"
        }, /*#__PURE__*/React.createElement("stop", {
          stopColor: "#00C6FF",
          offset: "0"
        }), /*#__PURE__*/React.createElement("stop", {
          stopColor: "#0068FF",
          offset: "1"
        }))), /*#__PURE__*/React.createElement("path", {
          fill: "url(#a)",
          d: "m41.255 185.52v40.2l37.589-21.37c10.478 3.02 21.616 4.65 33.156 4.65 61.86 0 112-46.79 112-104.5 0-57.714-50.14-104.5-112-104.5-61.856 0-112 46.786-112 104.5 0 32.68 16.078 61.86 41.255 81.02z"
        }), /*#__PURE__*/React.createElement("path", {
          fill: "#fff",
          d: "m100.04 75.878l-60.401 63.952 54.97-30.16 28.721 30.16 60.06-63.952-54.36 29.632-28.99-29.632z"
        }));
      } else if (name === 'fbReview') {
        icon = /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          style: icon_style,
          viewBox: "0 0 27 27"
        }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
          id: "fbreviewicon-a",
          r: "100%",
          fx: "50%",
          fy: "50%",
          gradientTransform: "matrix(0 1 -.84672 0 .923 0)"
        }, /*#__PURE__*/React.createElement("stop", {
          offset: "0%",
          stopColor: "#0068FF"
        }), /*#__PURE__*/React.createElement("stop", {
          offset: "100%",
          stopColor: "#00C6FF"
        }))), /*#__PURE__*/React.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, /*#__PURE__*/React.createElement("rect", {
          width: "18.754",
          height: "18.932",
          y: "8.068",
          fill: "#3B5998",
          rx: "2"
        }), /*#__PURE__*/React.createElement("path", {
          fill: "#FFF",
          fillRule: "nonzero",
          d: "M10.0004082,15.5330653 L10.0004082,14.332202 C10.0004082,13.8118279 10.1203838,13.5316264 10.9602123,13.5316264 L12,13.5316264 L12,11.5301875 L10.4003266,11.5301875 C8.40073484,11.5301875 7.60089814,12.8511372 7.60089814,14.332202 L7.60089814,15.5330653 L6.00122474,15.5330653 L6.00122474,17.5345043 L7.60089814,17.5345043 L7.60089814,23.538821 L10.0004082,23.538821 L10.0004082,17.5345043 L11.760049,17.5345043 L12,15.5330653 L10.0004082,15.5330653 Z"
        }), /*#__PURE__*/React.createElement("polygon", {
          fill: "url(#fbreviewicon-a)",
          stroke: "#FFF",
          points: "19.004 11.535 14.062 13.848 15.006 8.949 11.007 5.479 16.533 4.764 19.004 .307 21.475 4.764 27 5.479 23.002 8.949 23.946 13.848"
        })));
      } else if (name === 'bullhorn') {
        icon = /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          style: Object.assign({}, icon_style, {
            cursor: 'pointer'
          }),
          viewBox: "0 -256 1850 1850"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M1701.966 409.458q53 0 90.5 37.5t37.5 90.5q0 53-37.5 90.5t-90.5 37.5v384q0 52-38 90t-90 38q-417-347-812-380-58 19-91 66t-31 100.5q2 53.5 40 92.5-20 33-23 65.5t6 58q9 25.5 33.5 55t48 50q23.5 20.5 61.5 50.5-29 58-111.5 83t-168.5 11.5q-86-13.5-132-55.5-7-23-29.5-87.5t-32-94.5q-9.5-30-23-89t-15-101q-1.5-42 3.5-98.5t22-110.5h-122q-66 0-113-47t-47-113v-192q0-66 47-113t113-47h480q435 0 896-384 52 0 90 38t38 90v384zm-128 604v-954q-394 302-768 343v270q377 42 768 341z",
          fill: "currentColor"
        }));
      }

      return /*#__PURE__*/React.createElement("span", {
        onClick: this.props.onClick,
        style: {
          cursor: "".concat(this.props.onClick ? 'pointer' : 'default'),
          userSelect: "".concat(this.props.onClick ? 'none' : '')
        }
      }, icon);
    }
  }]);

  return Icon;
}(Component);

_defineProperty(Icon, "propTypes", {
  size: PropTypes.any,
  name: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func
});

_defineProperty(Icon, "defaultProps", {
  name: 'pencil',
  size: 'small',
  color: '#4a4a4a'
});

export { Icon as default };